import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Input, Label, ButtonGroup, Button } from "reactstrap";
import CustomSelect from '../../../Components/Common/CustomSelect';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getFeedInfoSuccess, setIsChangesMade } from '../../../slices/feeds/reducer';
import { intervalOption } from '../../../common/feedTypes';
import checkPermission from '../../../Components/Hooks/PermissionHook';

function FeedSettings() {
  const dispatch = useDispatch();
  const selectFeedInfo = createSelector((state) => state.Feed, (state) => state.feedInfo);
  const feedInfo = useSelector(selectFeedInfo);
  const [isSourceDisable, setIsSourceDisable] = useState(true);
  const [selectedIntervalOption, setSelectedIntervalOption] = useState({
    name: "Every week",
    value: 604800 * 1000
  });

  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  const canEdit = checkPermission("brands", brandPath, "feedEdit");

  useEffect(() => {
    if (feedInfo !== null) {
      setSelectedIntervalOption(intervalOption.find(item => item.value === feedInfo.interval));
    }
  }, [feedInfo])

  function handleChange(e) {
    dispatch(setIsChangesMade(true));
    if (e.target.name === 'name') {
      dispatch(getFeedInfoSuccess({ ...feedInfo, name: e.target.value }));
    } else if (e.target.name === "canBeEmpty") {
      dispatch(getFeedInfoSuccess({ ...feedInfo, canBeEmpty: !feedInfo.canBeEmpty }));
    } else if (e.target.name === "maxAmount") {
      dispatch(getFeedInfoSuccess({ ...feedInfo, maxAmount: e.target.value }));
    } 
  };

  function setSource() {
    dispatch(setIsChangesMade(true));
    setIsSourceDisable(true);
    const source = document.querySelector("#source");
    dispatch(getFeedInfoSuccess({ ...feedInfo, source: source.value }));
  }

  function setInterval(item) {
    dispatch(setIsChangesMade(true));
    dispatch(getFeedInfoSuccess({ ...feedInfo, interval: item.value }))
    setSelectedIntervalOption(item);
  }

  return (
    <Container fluid>
      <Row>
        <Col lg="4" md="12" sm="12">
          <Label htmlFor='name'>Feed Name</Label>
          <Input
            type='text'
            name='name'
            id="name"
            defaultValue={(feedInfo?.name || "")}
            onChange={handleChange}
            disabled={!canEdit}
          />
        </Col>
        <Col lg="4" md="12" sm="12">
          <Label htmlFor='maxAmount'>Max amount of items to include</Label>
          <Input
            type='text'
            name='maxAmount'
            id="maxAmount"
            defaultValue={(feedInfo?.maxAmount || "")}
            onChange={handleChange}
            disabled={!canEdit}
          />
        </Col>
        <Col lg="4" md="12" sm="12">
          <Label htmlFor='interval'>Update Interval</Label>
          <CustomSelect
            className='form-select'
            placeholder="Select Interval"
            options={intervalOption}
            onChange={(item) => setInterval(item)}
            disabled={!canEdit}
            value={(selectedIntervalOption?.name || '')}
          /> 
        </Col>
      </Row>
      <Row>
        <Col class="col-12">
          <div className='my-3'>
            <Label htmlFor='source'>Source</Label>
            <ButtonGroup className='w-100'>
              <Input type='text'
                name='source'
                id="source"
                className='form-control'
                defaultValue={(feedInfo?.source || "")}
                disabled={isSourceDisable}
              />
              {isSourceDisable ?
                <button class="btn btn-secondary bg-gray border-0 text-body" type='button'
                  onClick={() => setIsSourceDisable(false)}
                  disabled={!canEdit}>
                  Edit
                </button>
                :
                <>
                  <button className='btn btn-icon btn-success' type='button' onClick={setSource}>
                    <i className='ri-check-line align-center fs-20'></i>
                  </button>
                  <button className='btn btn-icon btn-secondary bg-gray border-0 text-body' type='button' onClick={() => setIsSourceDisable(true)}>
                    <i className='ri-close-line align-center fs-20'></i>
                  </button>
                </>
              }
            </ButtonGroup>
            {isSourceDisable === false ?
              <p className='m-0 mt-2 text-danger fs-12'>Changing feed source may break your feed</p>
              : null}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='col-12'>
          {canEdit ?
            <div className='form-check form-check-primary'>
              <Input
                className='form-check-input bg-light border-0'
                id='check'
                name='canBeEmpty'
                type='checkbox'
                checked={feedInfo?.canBeEmpty}
                onChange={handleChange} />
              <Label className='fw-normal' for='check'>Allow field values to be empty</Label>
            </div>
            : null}
          <p className='text-muted'>If a field value goes blank or empty after an update, your banners will display the last known value by default. Checking this box will allow banners to display blank values.</p>
        </Col>
      </Row>
    </Container>
  )
}

export default FeedSettings
